// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const raichu_alola: PokeData = {
  "id": 10100,
  "name": "raichu-alola",
  "height": 7,
  "weight": 210,
  "base_experience": 243,
  "types": [
    PokeType.ELECTRIC,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "slam",
    "tail-whip",
    "growl",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "psychic",
    "agility",
    "quick-attack",
    "double-team",
    "light-screen",
    "sweet-kiss",
    "charm",
    "spark",
    "encore",
    "iron-tail",
    "fake-out",
    "feint",
    "nasty-plot",
    "discharge",
    "electro-ball",
    "play-nice",
    "nuzzle",
    "speed-swap"
  ],
  "moves": [
    "growl",
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "psychic",
    "quick-attack",
    "sweet-kiss",
    "psy-pulse",
    "synchronize",
    "wild-charge",
    "zap-cannon",
    "prismatic-cage",
    "psychic-fangs"
  ],
  "evolution_chain": {
    "id": 10,
    "item": null,
    "species": [
      {
        "name": "pichu",
        "order": 25,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pikachu",
        "order": 26,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 172,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 220,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "raichu",
        "order": 27,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 25,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 164,
    "ability_power": 141
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
